import { z } from 'zod';

export const RACHEL_COMPACTING_DATA_PART = 'data-rachel-compacting' as const;

export const RachelCompactingPayloadSchema = z.object({
  phase: z.enum(['start', 'end']),
});

export type RachelCompactingPayload = z.infer<typeof RachelCompactingPayloadSchema>;
